import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Users, Home, Heart, ChevronRight, Calculator, Sparkles, PiggyBank, Palette } from "lucide-react";

const SECTIONS = [
  {
    title: "Polizza Sanitaria — RealmenteInSalute",
    desc: "Protezione sanitaria Reale Mutua: ricovero, intervento, alta diagnostica e visite specialistiche per te e la tua famiglia.",
    icon: Heart,
    link: "/questionario/sanitario",
    badge: "NOVITÀ",
    accent: true,
  },
  {
    title: "Assicurazione Casa",
    desc: "Proteggi la tua abitazione e il suo contenuto da incendio, furto, eventi atmosferici e responsabilità civile.",
    icon: Home,
    link: "/questionario/casa",
  },
  {
    title: "Assicurazione Vita",
    desc: "Protezione della famiglia, copertura mutuo, pensione integrativa e risparmio a lungo termine.",
    icon: Sparkles,
    link: "/questionario/vita",
  },
  {
    title: "Fine Arts — Opere d'Arte",
    desc: "Assicura le tue opere d'arte, collezioni private e beni di pregio con la copertura Lloyd's Chiodo a Chiodo dedicata ai collezionisti.",
    icon: Palette,
    link: "/questionario/fine-arts",
  },
  {
    title: "Fondi Pensione — PIP Reale Mutua",
    desc: "Costruisci la tua pensione integrativa con il Piano Individuale Pensionistico di Reale Mutua. Vantaggi fiscali fino a 5.164,57 € deducibili.",
    icon: PiggyBank,
    link: "/fondi-pensione",
  },
];

export default function FamigliaPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#FCFCFA] pt-20" data-testid="famiglia-page">
        <div className="max-w-3xl mx-auto px-5 sm:px-6 py-12">
          <div className="text-center mb-10">
            <div className="w-14 h-14 mx-auto mb-4 bg-[#163321]/10 rounded-full flex items-center justify-center">
              <Users className="w-7 h-7 text-[#163321]" />
            </div>
            <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-[#0F1F14] mb-3" data-testid="famiglia-title">
              Polizze per la Famiglia
            </h1>
            <p className="text-sm text-[#4A5E51] max-w-lg mx-auto">
              Proteggi ci&ograve; che conta di pi&ugrave;: la tua casa e il futuro della tua famiglia.
            </p>
          </div>

          <div className="space-y-4">
            {SECTIONS.map((s, i) => (
              <Link
                key={i}
                to={s.link}
                className={`block bg-white rounded-2xl p-6 premium-card transition-all group ${s.accent ? "border-2 border-[#D97B58]/40 hover:border-[#D97B58] bg-gradient-to-br from-[#FFF4EE] to-white" : "border border-[#E5E2DB] hover:border-[#163321]/30"}`}
                data-testid={`fam-section-${i}`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors shrink-0 ${s.accent ? "bg-[#D97B58]/15 group-hover:bg-[#D97B58]/25" : "bg-[#163321]/5 group-hover:bg-[#163321]/10"}`}>
                    <s.icon className={`w-6 h-6 ${s.accent ? "text-[#D97B58]" : "text-[#163321]"}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <h3 className="font-heading text-base sm:text-lg font-medium text-[#0F1F14] group-hover:text-[#163321] transition-colors">
                        {s.title}
                      </h3>
                      {s.badge && <span className="inline-block px-2 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wider bg-[#D97B58] text-white">{s.badge}</span>}
                    </div>
                    <p className="text-sm text-[#4A5E51] leading-relaxed">{s.desc}</p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-[#4A5E51] group-hover:text-[#163321] group-hover:translate-x-1 transition-all shrink-0 mt-1" />
                </div>
              </Link>
            ))}

            {/* Quotatore Vita */}
            <Link
              to="/quotatore"
              className="block bg-gradient-to-br from-[#163321] to-[#224A32] rounded-2xl p-6 hover:from-[#1a3d28] hover:to-[#2a5a3c] transition-all group"
              data-testid="fam-quotatore"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
                  <Calculator className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base sm:text-lg font-medium text-white mb-1">
                    Quotatore Polizza Vita
                  </h3>
                  <p className="text-sm text-white/70 leading-relaxed">
                    Calcola subito il capitale assicurato in base alla tua et&agrave; e al premio annuo scelto. Prodotto 282C — Reale Mutua.
                  </p>
                </div>
                <ChevronRight className="w-5 h-5 text-white/60 group-hover:translate-x-1 transition-all shrink-0 mt-1" />
              </div>
            </Link>
          </div>

          <div className="mt-10 text-center">
            <p className="text-xs text-[#4A5E51] italic">
              &ldquo;Parlerai con un consulente reale, non con un sistema automatico&rdquo;
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
